import * as React from 'react';
export const IcFlipHorizontal = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M3.64 6.23A1 1 0 002 7v10a1 1 0 001.64.77l6-5c.23-.19.36-.47.36-.77 0-.3-.13-.58-.36-.77l-6-5zM4 14.86V9.13L7.44 12 4 14.87v-.01zM12 3c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1zm9.42 3.09a.978.978 0 00-1.06.14l-6 5c-.23.19-.36.47-.36.77 0 .3.13.58.36.77l6 5a1.005 1.005 0 001.06.14c.35-.16.58-.52.58-.91V7a1 1 0 00-.58-.91z'
      fill='currentColor'
    />
  </svg>
);
